<template>
    <div :class="'endless-list-container ' + additionalClass">
        <b-table-simple class="endless-table" :small="small" borderless>
            <b-thead>
                <slot name="thead"></slot>
            </b-thead>
            <b-tbody>
                <b-tr v-for="item in localItems" class="endless-list-item" :key="item[keyProp]">
                    <slot v-bind:item="item">{{item}}</slot>
                    <b-td>
                        <b-button
                            v-if="!hideDeleteButton"
                            class="remove-button"
                            variant="danger"
                            v-b-tooltip.hover
                            title="Löschen"
                            :size="deleteButtonSize"
                            :disabled="busy"
                            @click="removeItem(item[keyProp])"
                        >
                            <font-awesome-icon icon="trash" />
                        </b-button>
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-td :colspan="colspan">
                        <b-button
                            v-if="!hideNewButton"
                            variant="secondary"
                            @click="addItem"
                            :disabled="busy"
                            size="sm"
                        >{{newItemButtonText}}</b-button>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import shortid from "shortid";

import "./EndlessTable.scss";

export default {
    name: "EndlessTable",
    props: {
        value: {
            type: Array,
            default: () => []
        },
        keyProp: {
            type: String,
            default: "id"
        },
        additionalClass: {
            type: String,
            default: ""
        },
        busy: {
            type: Boolean,
            default: false
        },
        deleteButtonSize: {
            type: String,
            default: "sm"
        },
        newItemBoilerplate: {
            type: Object,
            default: () => {}
        },
        hideNewButton: {
            type: Boolean,
            default: false
        },
        hideDeleteButton: {
            type: Boolean,
            default: false
        },
        colspan: {
            type: [Number, String],
            default: 1
        },
        small: {
            type: Boolean,
            default: false
        },
        newItemButtonText: {
            type: String,
            default: "Neue Daten hinzufügen"
        }
    },
    data() {
        return {
            localItems: []
        };
    },
    watch: {
        value: {
            handler(value) {
                this.localItems = value;
            },
            immediate: true
        },
        localItems: {
            handler(value) {
                this.$emit("input", value);
                this.$emit("update");
            },
            deep: true
        }
    },
    methods: {
        addItem() {
            const newItem = { ...this.newItemBoilerplate };
            newItem[this.keyProp] = "new_" + shortid.generate();
            this.localItems.push(newItem);
        },
        removeItem(id) {
            this.localItems = this.localItems.filter(item => item.id !== id);
        }
    }
};
</script>